import { WithId } from "src/types/id";
import { Selected, Tag } from "src/types/tags";
import { DEFAULT_CONFIG } from "./constants";

export type ModeAction = Mode;
export type Mode =
  | { type: "New"; initialName: string | null }
  | { type: "List" }
  | { type: "Edit"; tag: Tag<WithId> }
  | {
      type: "SelectGroup";
    };

export type TagsListEventHandler = {
  onSearch?: (keyword: string) => void;
  onTagUpdate?: (id: string, selected: Selected) => void;
  onNewTag?: (tag: string | null) => void;
  onEditTag?: (tag: Tag<WithId>) => void;
  onDeleteTag?: (tag: Tag<WithId>) => Promise<void>;
  onSelectTagGroup?: (id: string) => void;
};

export const extractEventHandlers = ({
  onSearch,
  onTagUpdate,
  onDeleteTag,
  onEditTag,
  onNewTag,
  onSelectTagGroup,
}: TagsListEventHandler): TagsListEventHandler => {
  return {
    onDeleteTag,
    onTagUpdate,
    onEditTag,
    onNewTag,
    onSearch,
    onSelectTagGroup,
  };
};

export type Config = {
  title?: string;
  maxLastUsedTagsCount?: number;
  allowNewTag?: boolean;
  allowEditTag?: boolean;
  allowDeleteTag?: boolean;
};

export type ConfigWithDefault = typeof DEFAULT_CONFIG;
